import React, { Component } from "react";
import DeliveryAndPaymentInformation from "../Components/Pages/staticPages/deliveryAndPayment/DeliveryAndPaymentInformation";

export default class GarantDeliveryAndPayment extends Component {
  render() {
    return (
      <div className="GarantDeliveryAndPayment">
        <DeliveryAndPaymentInformation />
      </div>
    );
  }
}
